import * as cytoscape from 'cytoscape';

export namespace Global {
  export var graphcy: cytoscape.Core;
}
